// extracted by mini-css-extract-plugin
export default {"button":"PlugNoAccess_button__y9tSD"};